module.exports = __webpack_public_path__ + "img/helu.9c17cb6d.jpg";